import React from "react";
import NumericInput from "react-numeric-input";
import { SVLNumericInputProps } from "./SVLNumericInput.definition";
import "./SVLNumericInput.scss";

const SVLNumericInput = (props: SVLNumericInputProps): JSX.Element => <NumericInput {...props} />;

export default SVLNumericInput;
